import { ROUTES } from '@/config/routes';

/**
 * Opens the order a timeline bar belongs to, in a new tab.
 *
 * A new tab rather than a navigation because a rail is a place you are reading: the order is a
 * detour from it, and coming back should not mean rebuilding the window you had scrolled to. Same
 * as the "View order" action on the space and package bookings tables.
 *
 * Callers pass an id only when the backend supplied one, which it does exactly for the orders the
 * viewer is a party to — there is no permission check to make here.
 */
export const openOrder = (orderId: string): void => {
  window.open(`${ROUTES.AUTHORIZED.ORDERS}/${orderId}`);
};
